/* eslint-disable
    default-case,
    eqeqeq,
    no-empty,
    no-shadow,
    no-unreachable,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS205: Consider reworking code to avoid use of IIFEs
 * DS206: Consider reworking classes to avoid initClass
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
let Socket;
const Backbone = require('app/scripts/lib/backbone');
const Util = require('app/scripts/lib/util');
const _ = require('underscore');
const log = require('app/scripts/debug/log');
const Browser = require('@trello/browser');
const { getQueryParameter } = require('app/scripts/lib/util');

const webSocketEvents = ['close', 'error', 'message', 'open'];
const DONT_COME_BACK_CODE = 4001;
const TERMINATED_SESSION_CODE = 4002;

module.exports = Socket = (function () {
  Socket = class Socket {
    static initClass() {
      this.CONNECTING = 'connecting';
      this.CONNECTED = 'connected';
      this.WAITING_TO_RECONNECT = 'waiting to reconnect';
      this.RECONNECTING = 'reconnecting';
      this.CLOSED = 'closed';
      this.DESTROYED = 'destroyed';
      this.PING_TIMEOUT = 30000;
      this.WAKE_UP_CHECK_INTERVAL = 2 * 1000;
    }
    constructor(url, param) {
      this.url = url;
      if (param == null) {
        param = {};
      }
      const {
        fxReconnectDelay,
        maxReconnectDelay,
        failedConsecutiveReconnectsLimit,
        reconnectRateLimit,
        reconnectRateWindow,
        maxReconnectsPerDay,
      } = param;
      this.fxReconnectDelay = fxReconnectDelay;
      this.maxReconnectDelay = maxReconnectDelay;
      this.failedConsecutiveReconnectsLimit = failedConsecutiveReconnectsLimit;
      this.reconnectRateLimit = reconnectRateLimit;
      this.reconnectRateWindow = reconnectRateWindow;
      this.maxReconnectsPerDay = maxReconnectsPerDay;
      _.extend(this, Backbone.Events);

      this.ws = null;

      this.resetRetries();

      for (const event of Array.from(webSocketEvents)) {
        this.listenTo(this, event, this[`on${Util.capitalize(event)}`]);
      }

      if (!('WebSocket' in window)) {
        this.trigger('connect_failed');
        return;
      }

      this.mustNeverReconnect = false;

      this.reconnectRateAttempts = 0;
      this.totalReconnects = 0;

      this._setDailyFailsCheck();

      this.connect();

      this.buffer = [];
      this.connectedOnce = false;

      this.wakeUpCheckLastRun = Date.now();
      this._wakeUpCheck = setInterval(() => {
        const currentTime = Date.now();
        // consider we just woke up if the last time we ran this interval, which
        // is supposed to run every two seconds, was more than [rate limit
        // window in ms] ago
        if (
          currentTime > this.wakeUpCheckLastRun + this.reconnectRateWindow &&
          !this.mustNeverReconnect
        ) {
          this.disconnect();
          this.reconnect();
        }
        return (this.wakeUpCheckLastRun = currentTime);
      }, Socket.WAKE_UP_CHECK_INTERVAL);

      this.trigger('connecting');
    }

    _setDailyFailsCheck() {
      return (this._dailyFailsCheck = setInterval(() => {
        this.totalReconnects = 0;
        if (this.state === Socket.CLOSED) {
          return this.reconnect();
        }
      }, Util.getMs({ days: 1 })));
    }

    _setReconnectBackOff() {
      if (this._timeoutBackOff != null) {
        return;
      }

      return (this._timeoutBackOff = setTimeout(() => {
        clearTimeout(this._timeoutBackOff);
        delete this._timeoutBackOff;

        this.reconnectRateAttempts = 0;

        if (this.state === Socket.CLOSED) {
          return this.reconnect();
        }
      }, this.reconnectRateWindow));
    }

    resetRetries() {
      return (this.failedConsecutiveReconnectAttempts = 0);
    }

    _clearPingTimeout() {
      if (this._pingTimeout != null) {
        clearTimeout(this._pingTimeout);
      }
      return (this._pingTimeout = null);
    }

    _resetPingTimeout() {
      this._clearPingTimeout();
      return (this._pingTimeout = setTimeout(
        this._noPing.bind(this),
        Socket.PING_TIMEOUT,
      ));
    }

    _noPing() {
      if (!this.state === Socket.CONNECTED) {
        return;
      }
      return this.disconnect();
    }

    connect() {
      let event;
      if (this.ws != null) {
        for (event of Array.from(webSocketEvents)) {
          this.ws[`on${event}`] = null;
        }
      }

      this.connectAttemptStarted = Date.now();
      this.ws = new WebSocket(this.url);

      for (event of Array.from(webSocketEvents)) {
        ((event) => {
          return (this.ws[`on${event}`] = function () {
            return this.trigger(event, ...arguments);
          }.bind(this));
        })(event);
      }

      return (this.state = Socket.CONNECTING);
    }

    onOpen(event) {
      if (this.connectedOnce) {
        this.trigger('reconnect');
      } else {
        this.trigger('connect');
      }

      this.connectedOnce = true;
      this.state = Socket.CONNECTED;
      this.flushBuffer();
      return this.resetRetries();
    }

    _triggerFailures() {
      if (this.state === Socket.CONNECTING) {
        return this.trigger('connect_failed');
      }
    }

    onClose(event) {
      this.trigger(
        'disconnect',
        (event != null ? event.reason : undefined) != null
          ? event != null
            ? event.reason
            : undefined
          : '',
      );

      if (
        (event != null ? event.code : undefined) === TERMINATED_SESSION_CODE
      ) {
        // Token has been invalidated and user
        // needs to be logged out.
        let redirectUrl = '/logged-out';
        if (
          Browser.isEmbeddedDocument() &&
          getQueryParameter('iframeSource', '') === 'msteams'
        ) {
          // MS Teams integration should redirect to the proper initial page, otherwise the page will not be displayable in the iframe
          redirectUrl = `/integrations/teams/tab-content?iframeSource=msteams&contentUrl=${encodeURIComponent(
            window.location.href,
          )}`;
        }
        window.location.replace(redirectUrl);
      }

      if ((event != null ? event.code : undefined) === DONT_COME_BACK_CODE) {
        this.mustNeverReconnect = true;
      }

      this._triggerFailures();
      this._clearPingTimeout();
      return this.reconnect(event);
    }

    onError(event) {
      this._triggerFailures();
      this.disconnect();
      return this.reconnect();
    }

    onMessage(event) {
      let parsedData;
      this._resetPingTimeout();
      if (event.data === '') {
        // This looks like a ping
        log('socket', 'responding to ping');
        this.ws.send('');
        return;
      }

      try {
        parsedData = JSON.parse(event.data);
      } catch (error) {}
      return this.trigger('data', parsedData);
    }

    _shouldNotReconnect() {
      if (this.reconnectNotAttemptedReason != null) {
        this.previousReason = this.reconnectNotAttemptedReason;
      }

      this.reconnectNotAttemptedReason = (() => {
        if (
          this.failedConsecutiveReconnectAttempts >=
          this.failedConsecutiveReconnectsLimit
        ) {
          return 'too many consecutive failures';
        } else if (this.mustNeverReconnect) {
          return 'server NEVER RECONNECT code received';
        } else if (this.reconnectRateAttempts >= this.reconnectRateLimit) {
          return 'rate limited';
        } else if (this.totalReconnects >= this.maxReconnectsPerDay) {
          return 'max reconnects limit reached';
        }
      })();

      return this.reconnectNotAttemptedReason != null;
    }

    reconnect(event) {
      switch (this.state) {
        case Socket.CONNECTED:
          this.ws.close();
          break;
        case Socket.RECONNECTING:
        case Socket.WAITING_TO_RECONNECT:
        case Socket.DESTROYED:
          return;
          break;
      }

      this._setReconnectBackOff();

      const previousCallAttemptedReconnect =
        this.reconnectNotAttemptedReason == null;

      if (this._shouldNotReconnect()) {
        if (previousCallAttemptedReconnect) {
          this.trigger('reconnect_failed');
        }
        this.state = Socket.CLOSED;
        return;
      }

      this.state = Socket.WAITING_TO_RECONNECT;

      if (this.failedConsecutiveReconnectAttempts === 0) {
        this.currentReconnectDelay = this.fxReconnectDelay(event);
      }

      log('socket', `attempting reconnect in ${this.currentReconnectDelay}ms`);

      this._reconnectTimer = setTimeout(() => {
        this._reconnectTimer = null;
        this.connect();
        this.state = Socket.RECONNECTING;
        return this.trigger('reconnecting');
      }, this.currentReconnectDelay);

      this.totalReconnects++;
      this.failedConsecutiveReconnectAttempts++;
      this.reconnectRateAttempts++;

      return (this.currentReconnectDelay = Math.min(
        2 * this.currentReconnectDelay,
        this.maxReconnectDelay,
      ));
    }

    // If a reconnect fails *really* quickly, we assume it's due to not having a connection
    // In this case, we can adjust the token buckets back down as we're not taxing the backend
    // This gives people more chance to re-connect while their wifi is connecting.
    _adjustTokenBuckets() {
      const fastFailure = this.connectAttemptStarted >= Date.now() - 20;
      if (
        this.state === Socket.RECONNECTING &&
        (!navigator.onLine || fastFailure)
      ) {
        this.totalReconnects = Math.max(this.totalReconnects - 1, 0);
        this.failedConsecutiveReconnectAttempts = Math.max(
          this.failedConsecutiveReconnectAttempts - 1,
          0,
        );
        this.reconnectRateAttempts = Math.max(
          this.reconnectRateAttempts - 1,
          0,
        );
        return (this.currentReconnectDelay = this.currentReconnectDelay / 2);
      }
    }

    disconnect() {
      if (this.state === Socket.DESTROYED) {
        return;
      }

      this._clearPingTimeout();
      this._adjustTokenBuckets();

      const { state } = this;
      // This needs to happen before @onClose, or we infinitely recurse
      this.state = Socket.CLOSED;

      switch (state) {
        case Socket.CONNECTED:
        case Socket.CONNECTING:
        case Socket.RECONNECTING:
          this.ws.close();
          // A client-initiated close doesn't trigger the handler
          return this.onClose();
        case Socket.WAITING_TO_RECONNECT:
          return clearTimeout(this._reconnectTimer);
      }
    }

    send(data) {
      if (this.state === Socket.CONNECTED) {
        try {
          return this.ws.send(data);
        } catch (error) {
          this.buffer.push(data);
          return this.onError();
        }
      } else {
        return this.buffer.push(data);
      }
    }

    flushBuffer() {
      const buf = this.buffer;
      this.buffer = [];
      return Array.from(buf).map((data) => this.send(data));
    }

    destroy() {
      // Clean up all the related timers to allow this object to be GC'd
      clearTimeout(this._reconnectTimer);
      clearTimeout(this._timeoutBackoff);
      clearTimeout(this._pingTimeout);
      clearInterval(this._dailyFailsCheck);
      clearInterval(this._wakeUpCheck);

      return (this.state = Socket.DESTROYED);
    }
  };
  Socket.initClass();
  return Socket;
})();
